import { render, staticRenderFns } from "./CursoOnlineBanner.vue?vue&type=template&id=c4a89f98&scoped=true&"
import script from "./CursoOnlineBanner.vue?vue&type=script&lang=js&"
export * from "./CursoOnlineBanner.vue?vue&type=script&lang=js&"
import style0 from "./CursoOnlineBanner.vue?vue&type=style&index=0&id=c4a89f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a89f98",
  null
  
)

export default component.exports